import { useQuery } from '@tanstack/react-query'
import { fetchActivities } from './api'

export function useActivities(...args: Parameters<typeof fetchActivities>) {
    return useQuery({
        queryFn: () => fetchActivities(...args),
        queryKey: ['activities', args],
        staleTime: 0,
    })
}
